import React, { useState } from 'react';
import { Link } from "react-router-dom";
import styled from 'styled-components';

const StyledNavBtn = styled.div`
  
  z-index: 20;
  margin: 0 7%;
  padding: 1.5em 0px;

  a div{    
    display: inline-block;    
    width: 100px;
    height: 43px;
    cursor: pointer;
    padding: 0 0.5em;
    background-repeat: no-repeat;
  }
  
  .prevBtn{
    background-image:url(./img/oleStarted/Prev_active.png);
    &:hover{
      background-image:url(./img/oleStarted/Prev_hover.png);
    }
  }
  .nextBtn{
    background-image:url(./img/oleStarted/Next_active.png);
    &:hover{
      background-image:url(./img/oleStarted/Next_hover.png);
    }
  }
`;

const NavBtn = ({ nextItem, prevItem }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <StyledNavBtn open={open} onClick={() => setOpen(!open)}>
        {
          prevItem &&
          <Link to={prevItem}><div className='prevBtn'></div></Link>
        }
        {nextItem &&
          <Link to={nextItem}><div className='nextBtn'></div></Link>
        }
      </StyledNavBtn>
    </>
  )
}

export default NavBtn
